module.exports = __webpack_public_path__ + "static/media/aboutus_hero.392a8baf.png";